import { getSyncProgressPercent } from "../../services/ebaySync";

function EbaySyncProgressBar({ counts, status, showLegend = true }) {
  const total = counts?.total || 0;
  const listed = counts?.listed || 0;
  const failed = counts?.failed || 0;
  const inQueue = counts?.in_queue || 0;
  const listing = counts?.listing || 0;
  const done = counts?.done ?? listed + failed;
  const percent = getSyncProgressPercent(counts);

  const listedPct = total ? (listed / total) * 100 : 0;
  const failedPct = total ? (failed / total) * 100 : 0;
  const activePct = total ? ((inQueue + listing) / total) * 100 : 0;

  return (
    <div className="ebay-sync-detail__progress">
      <div className="ebay-sync-detail__progress-header">
        <h3 className="ebay-sync-detail__progress-title">
          {status === "running" ? "Sync in progress" : "Sync progress"}
        </h3>
        <span className="ebay-sync-detail__progress-count">
          {done} / {total} ({percent}%)
        </span>
      </div>

      <div className="ebay-sync-detail__bar">
        {listedPct > 0 && (
          <div
            className="ebay-sync-detail__bar-segment ebay-sync-detail__bar-segment--listed"
            style={{ width: `${listedPct}%` }}
          />
        )}
        {failedPct > 0 && (
          <div
            className="ebay-sync-detail__bar-segment ebay-sync-detail__bar-segment--failed"
            style={{ width: `${failedPct}%` }}
          />
        )}
        {status === "running" && activePct > 0 && (
          <div
            className="ebay-sync-detail__bar-segment ebay-sync-detail__bar-segment--active"
            style={{ width: `${activePct}%` }}
          />
        )}
      </div>

      {showLegend && (
        <div className="ebay-sync-detail__legend">
          <span className="ebay-sync-detail__legend-item">
            <span
              className="ebay-sync-detail__legend-dot"
              style={{ background: "#10b981" }}
            />
            Listed - {listed}
          </span>
          <span className="ebay-sync-detail__legend-item">
            <span
              className="ebay-sync-detail__legend-dot"
              style={{ background: "#3b82f6" }}
            />
            In progress - {inQueue + listing}
          </span>
          <span className="ebay-sync-detail__legend-item">
            <span
              className="ebay-sync-detail__legend-dot"
              style={{ background: "#ef4444" }}
            />
            Failed - {failed}
          </span>
        </div>
      )}
    </div>
  );
}

export default EbaySyncProgressBar;
